import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Gift } from 'lucide-react';
export function HeroSectionV5() {
  const scrollToOffer = () => {
    const target = document.getElementById('oferta-resumen');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-6 pb-10 px-4 md:pt-12 md:pb-16 overflow-hidden bg-gradient-to-b from-[#FFF8F0] to-[#FFE0B2]/30" data-id="element-438">
      <div className="max-w-lg md:max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-439">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-440">
          <span className="inline-block py-1 px-3 rounded-full bg-[#E8F5E9] text-[#2E7D32] text-sm font-bold mb-6 tracking-wide" data-id="element-441">
            🥦 NUTRIPEQUES
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6 text-balance" data-id="element-442">
            "Tu hijo no rechaza la comida. Rechaza el caos. Y esto lo soluciona
            en <span className="text-[#FF8A65]" data-id="element-443">30 minutos por semana</span>."
          </h1>
          <p className="text-lg md:text-2xl text-gray-700 mb-5 font-medium" data-id="element-444">
            Guía práctica de alimentación infantil sin estrés
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-md mx-auto mb-2 relative" data-id="element-445">
          {/* 3D Box Effect for Video */}
          <div className="absolute inset-0 bg-gradient-to-tr from-[#FF8A65] to-[#FFCC80] blur-2xl rounded-[2rem] transform scale-105 opacity-60 animate-pulse" data-id="element-446"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full max-w-md mx-auto mb-10 relative cursor-pointer group" onClick={scrollToOffer} data-id="element-447">
          <div className="absolute inset-0 bg-gradient-to-tr from-[#FF8A65] to-[#FFCC80] blur-xl rounded-[1rem] transform scale-105 opacity-40 group-hover:opacity-70 transition-opacity duration-300" data-id="element-448"></div>
          <img src="https://cdn.magicpatterns.com/uploads/wjcDDNGXW1T2wwrE1m7ksV/heylloyd-image-1772533088855.png" alt="NutriPeques + Bonos" className="relative z-10 w-full h-auto rounded-[1rem] shadow-[0_10px_30px_rgba(255,138,101,0.2)] group-hover:scale-[1.02] transition-transform duration-300 border-2 border-white" data-id="element-449" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full max-w-md" data-id="element-450">
          {/* 3 Checks */}
          <div className="flex flex-col gap-3 mb-6 text-left bg-white/60 p-5 rounded-2xl border border-orange-100 shadow-sm" data-id="element-451">
            <div className="flex items-center gap-3" data-id="element-452">
              <div className="bg-orange-100 p-1.5 rounded-full shrink-0" data-id="element-453">
                <Zap className="w-5 h-5 text-[#E65100]" data-id="element-454" />
              </div>
              <span className="font-bold text-gray-800" data-id="element-455">
                Acceso Inmediato:{' '}
                <span className="text-gray-400 line-through text-sm" data-id="element-456">$39</span>{' '}
                <span className="inline-block bg-[#E65100] text-white text-sm font-black px-2 py-0.5 rounded-md shadow-sm ml-0.5" data-id="element-457">
                  HOY SOLO $14.99
                </span>
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-458">
              <div className="bg-green-100 p-1.5 rounded-full shrink-0" data-id="element-459">
                <ShieldCheck className="w-5 h-5 text-[#2E7D32]" data-id="element-460" />
              </div>
              <span className="font-bold text-gray-800" data-id="element-461">
                Garantía Total de 7 Días
              </span>
            </div>
            <div className="flex items-center gap-3 bg-[#FFF3E0] p-2 -mx-2 rounded-xl border border-[#FFE0B2] animate-[pulse_3s_infinite]" data-id="element-462">
              <div className="bg-[#E65100] p-1.5 rounded-full shrink-0 shadow-md" data-id="element-463">
                <Gift className="w-5 h-5 text-white animate-bounce" data-id="element-464" />
              </div>
              <span className="font-black text-[#E65100] uppercase tracking-wide" data-id="element-465">
                Bonos sorpresa incluidos
              </span>
            </div>
          </div>

          <button onClick={scrollToOffer} className="w-full min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-xl font-bold rounded-2xl shadow-[0_8px_0_#1B5E20] hover:shadow-[0_4px_0_#1B5E20] hover:translate-y-1 transition-all flex items-center justify-center gap-2 px-6 mb-8" data-id="element-466">
            → Quiero nutrir con calma
          </button>

          <div className="text-center" data-id="element-467">
            <p className="text-base md:text-lg font-bold text-gray-800 flex items-center justify-center gap-2 mb-2" data-id="element-468">
              <span className="flex items-center text-yellow-400" data-id="element-469">
                ⭐⭐⭐⭐⭐
              </span>
              <span data-id="element-470">+3000 mamás ya lo aprueban</span>
            </p>
            <p className="text-sm md:text-base text-gray-600" data-id="element-471">
              Método para niños de 1 a 7 años.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}